import React from 'react';
import PropTypes from 'prop-types';
import { ImageBlock } from '../../components/Blocks/ImageBlock';
import bg from '../../assets/newbg.jpg'

import logo from '../../assets/system3-logo.svg'
import './SystemLogo.scss'
import { cssUrl } from '../../tools/Utils';

export class MobileLogo extends React.Component
{

	render()
	{
		return (
			<ImageBlock src={bg} className="system-logo">
				<img src={cssUrl(logo)} />
				<h1>SYSTEM·<span>3</span></h1>
				<h3>MARKETING <span>·</span> DESARROLLO <span>·</span> SAT</h3>
			</ImageBlock>
		);
	}
}